const subscription = {
    limit_exceeded: 'Abonelik planınızın limitine ulaştınız.',
    get_plan_failed: 'Abonelik planınızı almak için başarısız oldu.',
    tenant_suspended: 'Kiracı askıya alındı. Lütfen yöneticinize başvurun.',
};
export default Object.freeze(subscription);
